export const invalidPhoneNumber = function(value, field, model, messages=null) {

    if (!value) {
        return [];
    }

    // does string have alphabetic characters
    if (value.match(/[a-z]/i)) {
        if (!messages) {
            return ['Invalid phone number'];
        } else {
            return [messages.invalidPhoneNumber];
        }
    }

    // remove special characters
    let phoneNumber = value.replace(/\D/g, '');

    // validate remaining phone number, must be between 3 and 15 digits
    const validPhone = (phone) => /^\s*(?:\+?(\d{1,5}))?[-. (]*(\d{1,3})[-. )]*(\d{1,3})[-. ]*(\d{1,4})(?: *x(\d+))?\s*$/.test(phone);
    if (!validPhone(phoneNumber)) {
        if (!messages) {
            return ['Invalid phone number.'];
        } else {
            return [messages.invalidPhoneNumber];
        }
    }
    return [];
}
